<template>
    <forgot-loader v-show="loading"></forgot-loader>
    <div v-show="!loading" class="page-wrapper">
        <img class="login-bg" :src="selectedImage" alt="">
        <div class="login-form">
            <p class="login-form-title">Forgot Password </p>
            
            <label>
                <input required="" placeholder="" type="email" class="input" v-model="email" id="email">
                <span id="label-email">Email</span>
                <div class="error-message">{{ errorEmail }}</div>
            </label> 

            <button class="login-form-submit" @click="reset">Reset</button>
            <router-link :to="{name: 'login'}" class="back-btn">
                <i class="fa-solid fa-angles-left"></i> <span>Back</span>
            </router-link>

            <span class="login-bottom-text">
              <span class="copyright">©</span> 
                ESS IRIS INTERNATIONAL 
              <span class="version">Beta</span>
            </span>
        </div>
    </div>

    <alert v-if="showAlert" 
          :message="message" 
          :status="status" 
          :type="types"
          @clicked="onClosedAlert">
    </alert>
</template>

<script>
import ForgotLoader from '@/components/Loader/ForgotLoader.vue';
import Alert from '@/components/Alert.vue';
import axios from 'axios';

export default {
    name: 'ForgotPasswordView',
    components: {
      ForgotLoader,
      Alert,
    },
    data(){
      return {
          showAlert: false,
          message: null,
          status: null,
          types: null,
          email: null,
          password: '',
          errorNik: null,
          errorPass: null,
          loading: true,
          images: [
            '/assets/images/bg-1.png',
            '/assets/images/bg-2.png',
            '/assets/images/bg-3.png',
            '/assets/images/bg-4.png',
            '/assets/images/bg-5.png',
            '/assets/images/bg-6.png',
            '/assets/images/bg-7.png',
            '/assets/images/bg-8.png',
          ],
          selectedImage: null,
      }
    },
    watch: {
        selectedImage: function() {
          var root = document.documentElement;
          switch (this.selectedImage) {
            case "/assets/images/bg-1.png":
                root.style.setProperty("--logincolor", "#2a85b2");
                root.style.setProperty("--loginhover", "#1b5c7c");
                break;
            case "/assets/images/bg-2.png":
                root.style.setProperty("--logincolor", "#f5e087");
                root.style.setProperty("--loginhover", "#d3b15f");
                break;
            case "/assets/images/bg-3.png":
                root.style.setProperty("--logincolor", "#9be3bd");
                root.style.setProperty("--loginhover", "#82caaa");
                break;
            case "/assets/images/bg-4.png":
                root.style.setProperty("--logincolor", "#dab2b2");
                root.style.setProperty("--loginhover", "#c99797");   
                break;
            case "/assets/images/bg-5.png":
                root.style.setProperty("--logincolor", "#ba99e4");
                root.style.setProperty("--loginhover", "#9374ae");
                break;
            case "/assets/images/bg-6.png":
                root.style.setProperty("--logincolor", "#e3be9a");
                root.style.setProperty("--loginhover", "#d0a87f");
                break;
            case "/assets/images/bg-7.png":
                root.style.setProperty("--logincolor", "#4e9c87");
                root.style.setProperty("--loginhover", "#258672");
                break;
            case "/assets/images/bg-8.png":
                root.style.setProperty("--logincolor", "#ef5656");
                root.style.setProperty("--loginhover", "#c53631");
            }
        },
        email: function() {
            this.checkFocus('email', this.email);
        },
    },
    created() {
      setTimeout(() => {this.loading = false}, 1000);
      this.selectedImage = this.randomItem(this.images)
    },
    methods: {
      onClosedAlert(value){this.showAlert = value},
      reset(){
        const data = {
          email: this.email
        }

        axios.post('/forgot_password', data)
        .then((res) => {
          this.message = res.data.message
          this.status = true
          this.types = 'login'
          this.showAlert = true
        })
        .catch((err) => {
          this.message = err.response.data.message
          this.status = false
          this.showAlert = true
        })
      },
      checkFocus(id, data){
        const div = document.getElementById(id);
        if(data !== '') {
          div.focus();
          const label = document.getElementById("label-" + id);
          label.style.fontFamily = 'Arial, Helvetica, sans-serif';
          label.style.top = '30px';
          label.style.fontSize = '8pt';
          label.style.fontWeight = '600';
        } else { 
          div.blur();
          const label = document.getElementById("label-" + id);
          label.style.fontFamily = 'Arial, Helvetica, sans-serif';
          label.style.top = '15px';
          label.style.fontSize = '11pt';
          label.style.fontWeight = '400';
        }
      },
      randomItem (items) {
        return items[Math.floor(Math.random()*items.length)];
      },
      login(){
        
        if(!this.nik) this.errorNik = "Field NIK harus diisi!";
        if(!this.password) this.errorPass = "Field password harus diisi";

        if(this.nik && this.password){
          localStorage.setItem('nik', this.nik);
          localStorage.setItem('password', this.password);
          if(localStorage.getItem('nik') && localStorage.getItem('password')){
            this.$router.push({name: 'home'});
          }
        }

        setTimeout(() => {
            this.errorNik = null;
            this.errorPass = null;
        }, 5000);
      }
    },
}
</script>

<style>

</style>